module.exports = __webpack_public_path__ + "img/icon-jinju-logo.bf6cf413.png";